import React, { useEffect, useState } from 'react';

import UndefinedContractsProps from './UndefinedContractsTypes';
import SpinnerOverlayBox from './SpinnerOverlayBox';
import ContractsSubmit from './ContractsSubmit';
import ProviderFetch from './Actions';
import ProductSelect from './ProductSelect';
import AutocompleteInput from './AutocompleteInput';
import {
    Title,
    UndefinedContractsWrapper,
    ColumnButton,
    SelectColumn,
    TitleContainer,
} from './StyledUndefinedContractsElements';
import { InfoIcon } from '../StyledManagerMobile';

const UndefinedContracts: React.FC<UndefinedContractsProps> = (props) => {
    const { formDefinition, jumpinUrl, title, infoTextProvider, leads } = props;

    const [providerList, setProviderList] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState({});
    const [selectedProvider, setSelectedProvider] = useState({ provider_name: '' });
    const [loading, setLoading] = useState<boolean>(false);
    const [searchValue, setSearchValue] = useState<string>('');

    const fieldEvent = formDefinition[0]?.events?.[0];
    const fieldAction = fieldEvent?.actions[0];

    useEffect(() => {
        // @ts-ignore
        if (!selectedProduct.productKey) {
            return;
        }

        /* @ts-ignore */
        const apiUrl = fieldAction?.apiUrls[selectedProduct?.apiUrlKey || 'energy'];
        // @ts-ignore
        const fetchUrl = apiUrl.replace('%7BproductKey%7D', selectedProduct.productKey);

        setLoading(true);

        ProviderFetch(fetchUrl)
            .then((dataList: []) => {
                setProviderList(dataList);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [selectedProduct]);

    return (
        <UndefinedContractsWrapper>
            <TitleContainer className={leads.length > 0 ? '' : 'title-margin-top'}>
                <Title>{title}</Title>
                <InfoIcon infoText={infoTextProvider} />
            </TitleContainer>

            <SelectColumn>
                <ProductSelect
                    definition={formDefinition}
                    setActiveProduct={setSelectedProduct}
                    activeProduct={selectedProduct}
                    setActiveSearchValue={setSearchValue}
                    activeSearchValue={searchValue}
                    setActiveProvider={setSelectedProvider}
                />
            </SelectColumn>

            <SelectColumn>
                <AutocompleteInput
                    activeProvider={selectedProvider}
                    loading={loading}
                    setActiveProvider={setSelectedProvider}
                    providerList={providerList}
                    setActiveSearchValue={setSearchValue}
                    activeSearchValue={searchValue}
                />
            </SelectColumn>

            <ColumnButton>
                <ContractsSubmit
                    product={selectedProduct}
                    provider={selectedProvider}
                    jumpinUrl={jumpinUrl}
                    formDefinition={formDefinition}
                />
            </ColumnButton>

            <SpinnerOverlayBox loading={loading} />
        </UndefinedContractsWrapper>
    );
};

export default UndefinedContracts;
